import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
  ApiYAxisChartType,
} from "@incendium/api";
import { Grid } from "@mui/material";
import { AnalyticsSpacing } from "consts";
import { table10Rows, table2Rows } from "features/analytics";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import { useMetricName } from "features/analytics/hooks/useMetricName";
import { useState } from "react";
import {
  CHART_KEY_DEVICE_INSIGHTS_BROWSER_TABLE,
  CHART_KEY_DEVICE_INSIGHTS_COMPOSITION_PIE,
  CHART_KEY_DEVICE_INSIGHTS_DEVICE_TABLE,
  CHART_KEY_DEVICE_INSIGHTS_TYPE_TREND,
} from "features/analytics/constants/chartKeys";

function DevicesInsights() {
  const metricToName = useMetricName();
  const [metric, setMetric] = useState<ApiMetric>(
    ApiMetric.METRIC_SESSIONS_COUNT,
  );

  return (
    <Grid container spacing={AnalyticsSpacing} mb={4}>
      <Grid item xs={4} sx={{ minHeight: 450 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DEVICE_INSIGHTS_COMPOSITION_PIE}
          chart={{
            name: `${metricToName(metric)} Composition by Devices`,
            dimension: [ApiDimension.DIMENSION_DEVICE],
            template: ApiChartTemplate.SNAPSHOT,
            type: ApiChartType.PIE,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
              },
            ],
            displayOptions: {
              showTotals: true,
            },
          }}
        />
      </Grid>
      <Grid item xs={8} sx={{ minHeight: 450 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DEVICE_INSIGHTS_TYPE_TREND}
          chart={{
            name: "Device Type by",
            dimension: [
              ApiDimension.DIMENSION_SESSION_START_BY_DAY,
              ApiDimension.DIMENSION_DEVICE,
            ],
            template: ApiChartTemplate.TREND,
            type: ApiChartType.GRAPH,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
                chart: {
                  [ApiMetric.METRIC_SESSIONS_COUNT]: ApiYAxisChartType.AREA,
                  [ApiMetric.METRIC_EFFECTIVE_SESSION_RATE]:
                    ApiYAxisChartType.LINE,
                  [ApiMetric.METRIC_MACRO_CONVERSION_RATE]:
                    ApiYAxisChartType.LINE,
                },
              },
            ],
            displayOptions: {
              availableMetrics: [
                ApiMetric.METRIC_SESSIONS_COUNT,
                ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                ApiMetric.METRIC_PAGE_MICRO_CONVERSIONS_COUNT,
              ],
            },
          }}
          onChangeMetric={setMetric}
        />
      </Grid>
      <Grid item xs={12} sx={{ minHeight: table2Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DEVICE_INSIGHTS_DEVICE_TABLE}
          chart={{
            name: ``,
            dimension: [ApiDimension.DIMENSION_DEVICE],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
                  ApiMetric.METRIC_AVERAGE_VIEWED_PERCENTAGE,
                  ApiMetric.METRIC_AVERAGE_SCROLL_PERCENTAGE,
                  ApiMetric.METRIC_AVERAGE_SCROLL_SPEED,
                  ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_EFFECTIVE_SESSIONS_TO_CONVERSION_RATE,
                  ApiMetric.METRIC_REVENUE,
                ],
              },
            ],
          }}
        />
      </Grid>
      <Grid item xs={12} sx={{ minHeight: table10Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DEVICE_INSIGHTS_BROWSER_TABLE}
          chart={{
            name: ``,
            dimension: [ApiDimension.DIMENSION_BROWSER],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            displayOptions: {
              rowsPerPage: 0,
            },
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
                  ApiMetric.METRIC_AVERAGE_VIEWED_PERCENTAGE,
                  ApiMetric.METRIC_AVERAGE_SCROLL_PERCENTAGE,
                  ApiMetric.METRIC_AVERAGE_SCROLL_SPEED,
                  ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_EFFECTIVE_SESSIONS_TO_CONVERSION_RATE,
                  ApiMetric.METRIC_REVENUE,
                ],
              },
            ],
          }}
        />
      </Grid>
    </Grid>
  );
}

export default DevicesInsights;
